import { render } from "./CustomerUpdate.vue?vue&type=template&id=13b924e0"
import script from "./CustomerUpdate.vue?vue&type=script&lang=js"
export * from "./CustomerUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__